<template>
  <div  v-if="showGoodsLimit">
    <div class="goods-limit">
      <div class="header">
        <div class="back" @click="closeGoodsLimit">返回</div>
        <div class="task-title">
          {{ taskList[taskIndex].taskContentName }}-限定品种
        </div>
      </div>
      <div class="goods-content">
        <div class="search-wrap">
          <el-row :gutter="24">
            <el-col :span="8">
              <div class="search-area-div w80" style="font-size:14px">产品名称：</div>
              <el-input v-model="page.goodsName" class="ipt-sty" placeholder="请输入"></el-input>
            </el-col>
            <el-col :span="8">
              <div class="search-area-div w80" style="font-size:14px">是否竞品：</div>
              <el-select v-model="page.isCompetitor" placeholder="请选择" class="ipt-sty w70f" clearable>
                <el-option v-for="item in [{ label: '是', value: 'Y' }, { label: '否', value: 'N' }]" :key="item.value"
                  :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <el-button size="mini" type="info" @click="getGoodsListByGuids">搜索</el-button>
              <el-button size="mini" type="danger" @click="emptySearchProducts">清空</el-button>
            </el-col>
          </el-row>
        </div>
        <div v-if="!disabled" class="btn-groups-operate" style="justify-content: flex-start;">
          <el-button size="mini" type="info" class="btn" @click="goodsVisible=true;getGoodsList()">选择产品</el-button>
          <el-button size="mini" type="info" class="btn" @click="downLoadExcel">下载导入模板</el-button>
          <el-upload class="upload-demo" action="#" multiple :limit="1" accept=".xlsx,.xsl,.xlsm"
            :before-upload="beforeUpload" :on-exceed="handleExceed" :http-request="changeFile" :file-list="fileList"
            :show-file-list="false">
            <el-button size="mini" type="info" class="btn" >批量导入产品</el-button>
          </el-upload>
          <el-button size="mini" type="danger" class="btn" @click="emptyProducts">清空产品</el-button>
        </div>
        <div class="back-color-fff content-main-box"  style="width: 100%;height:calc(100% - 80px);">
          <el-table :data="productInformationList"
            stripe border
            header-cell-class-name="table_header">
            <el-table-column prop="goodsName" label="产品名称" header-align="center" align="left" show-overflow-tooltip>
              <template slot-scope="scope"> {{ scope.row.goodsName }} </template>
            </el-table-column>
            <el-table-column prop="goodsSpec" label="规格" header-align="center" align="left" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="price" width="80" label="单位" header-align="center" align="center">
              <template slot-scope="scope"> {{ scope.row.unitStyle }} </template>
            </el-table-column>
            <el-table-column prop="producer" label="生产企业" header-align="center" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="price" width="80" label="是否竞品" header-align="center" align="center">
              <template slot-scope="scope"> {{ scope.row.isCompetitor == 'Y' ? '是' : '否' }} </template>
            </el-table-column>
            <el-table-column prop="price" label="产品编码" header-align="center" align="center">
              <template slot-scope="scope"> {{ scope.row.goodsCode||'-'}} </template>
            </el-table-column>
            <el-table-column prop="price" width="80" label="操作" header-align="center" align="center" v-if="!disabled">
              <template slot-scope="scope">
                <a class="txt-color" @click="delData(scope.row.guid)">
                  删除
                </a>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination class="pt back-color-fff" background @size-change="productsSizeChange"
          @current-change="productsCurrentChange" :current-page="page.pageIndex" :page-size="page.pageSize"
          layout="total, prev, pager, next, jumper" :total="page.totalRows">
        </el-pagination>
        <div class="btn-groups-operate">
          <el-button v-if="!disabled" size="mini" type="" class="btn" @click="closeGoodsLimit">取消</el-button>
          <el-button v-if="!disabled" size="mini" type="info" class="btn" @click="submitForm('Y')">提交，并同时提交给其他任务</el-button>
          <el-button v-if="!disabled" size="mini" type="info" class="btn" @click="submitForm('N')">提交</el-button>
        </div>
      </div>
    </div>
    <!-- 产品选择弹窗 开始 -->
    <el-dialog title="选择产品" v-if="goodsVisible" :visible.sync="goodsVisible" width="70%" center>
      <el-row :gutter="24" class="mb30">
        <el-col :span="8">
          <div class="search-area-div w80">产品名称：</div>
          <el-input v-model="goodsPage.goodsName" class="ipt-sty" placeholder="请输入"></el-input>
        </el-col>
        <el-col :span="8">
          <div class="search-area-div w80" style="font-size:14px">是否竞品：</div>
          <el-select v-model="goodsPage.isCompetitor" placeholder="请选择" class="ipt-sty w70f" clearable>
            <el-option v-for="item in [{ label: '是', value: 'Y' }, { label: '否', value: 'N' }]" :key="item.value"
              :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <el-button size="mini" type="info" @click="getGoodsList">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearchGoods">清空</el-button>
        </el-col>
      </el-row>
      <div class="back-color-fff content-main-box"  style="width: 100%;height:500px">
      <el-table :data="goodsInfoList" style="width: 100%; border-bottom: 1px solid #EBEEF5 !important;" stripe border
        header-cell-class-name="table_header" row-key="guid" @selection-change="handleSelectionChange" ref="dataTable"
        @row-click="btn">
        <el-table-column type="selection" :reserve-selection="true"> </el-table-column>
        <el-table-column prop="goodsName" label="产品名称" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope"> {{ scope.row.goodsName }} </template>
        </el-table-column>
        <el-table-column prop="goodsSpec" label="规格" header-align="center" align="left" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="price" width="80" label="单位" header-align="center" align="center">
          <template slot-scope="scope"> {{ scope.row.unitStyle }} </template>
        </el-table-column>
        <el-table-column prop="producer" label="生产企业" header-align="center" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="price" width="80" label="是否竞品" header-align="center" align="center">
          <template slot-scope="scope"> {{ scope.row.isCompetitor == 'Y' ? '是' : '否' }} </template>
        </el-table-column>
        <el-table-column prop="price" label="产品编码" header-align="center" align="center">
          <template slot-scope="scope"> {{ scope.row.goodsCode||'-'}} </template>
        </el-table-column>
      </el-table>
      </div>
      <el-pagination class="pt pb back-color-fff" background @size-change="goodsSizeChange"
        @current-change="goodsCurrentChange" :current-page="goodsPage.pageIndex" :page-size="goodsPage.pageSize"
        layout="total, prev, pager, next, jumper" :total="goodsPage.totalRows">
      </el-pagination>
      <div slot="footer" class="dialog-footer t-right">
        <el-button plain size="medium" @click="goodsVisible = false">取消</el-button>
        <el-button size="medium" type="info" @click="sureChooseGoods">确定</el-button>
      </div>
    </el-dialog>
    <!-- 产品选择弹窗 结束 -->

    <!-- 超龄弹层 开始 -->
    <el-dialog :visible.sync="importVisible" width="670px">
      <template slot="title">
        <span >导入结果提醒</span>
      </template>
      <div class="tips">
        <div> 共导入产品 {{ successImportList.length + errorImportList.length }} 条，导入成功 {{successImportList.length}} 条，失败 {{errorImportList.length}} 条。</div> 
        <div> 以下产品不存在，请检查!</div>
      </div>
      <div class="back-color-fff content-main-box" style="max-height: 600px;height: auto;">
        <el-table border :data="errorImportList" style="width:100%;">
          <el-table-column label="失败产品名称" prop="goodsName" show-overflow-tooltip header-align="center" align="left">
            <template slot-scope="scope"> {{ scope.row.goodsName||'-'}} </template>
          </el-table-column>
          <el-table-column label="产品规格" prop="goodsSpec" header-align="center" align="left"> 
            <template slot-scope="scope"> {{ scope.row.goodsSpec||'-'}} </template>
          </el-table-column>
          <el-table-column label="生产企业" prop="producer" header-align="center" align="left"> 
            <template slot-scope="scope"> {{ scope.row.producer||'-'}} </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button size="medium" type="info" @click="downloadOverAgeList">下载人员名单
        </el-button> -->
        <el-button size="medium" plain @click="importVisible = false;">我知道了</el-button>
      </span>
    </el-dialog>
    <!-- 超龄弹层 结束-->
  </div>
</template>
  
  <script>
  import moment from 'moment';

  
  export default {
    props:['showFromLevel','taskList','taskIndex','sendTenantGuid','disabled'],
    data() {
      let userinfo = JSON.parse(localStorage.userInfo);
      return {
        showGoodsLimit: false,
        page: {
          pageIndex: 1,
          pageSize: 50,
          totalRows: 0,
          goodsName: null,
          isCompetitor: ''
        },
        productInformationList: [],
        //选择产品弹窗
        goodsVisible: false,
        goodsInfoList:[],
        goodsPage:{
          pageIndex: 1,
          pageSize: 50,
          totalRows: 0,
          totalPage:0,
          goodsName: null,
          tenantGuid:null,
          isCompetitor: 'N'
        },
        //多选后的列表
        multipleSelection:[],
        fileList:[],
        importVisible:false,
        errorImportList:[],
        successImportList:[],

      };
    },
    created() {

    },
    watch: {
        showFromLevel(value){
          this.showGoodsLimit = value;
          let multipleSelection = [];
          let list = this.taskList[this.taskIndex].multipleSelection || this.taskList[this.taskIndex].goodsInfo;
          if (typeof list == 'string') {
            list = JSON.parse(list);
          }
          if (list) {
            list.forEach(item => {
              multipleSelection.push(item.guid);
            })
          }
       
          if (multipleSelection.length) {
            this.multipleSelection = multipleSelection;
            this.getGoodsListByGuids();
          } else {
            this.page = {
              pageIndex: 1,
              pageSize: 50,
              totalRows: 0,
              goodsName: null,
              isCompetitor: null
            }
          this.productInformationList = [];
          this.multipleSelection = [];

          }
        }
    },
    methods: {
      closeGoodsLimit() {
        this.page = {
          pageIndex: 1,
          pageSize: 50,
          totalRows: 0,
          goodsName: null,
          isCompetitor: null
        }
        this.goodsPage = {
          pageIndex: 1,
          pageSize: 50,
          totalRows: 0,
          totalPage: 0,
          goodsName: null,
          tenantGuid: null
        }
        this.productInformationList = [];
        this.multipleSelection = [];
        this.$emit('closeGoodsLimit')
      },
      //选择产品后的分页
      productsSizeChange(pageSize) {
        this.page.pageSize = pageSize;
        this.getGoodsListByGuids()
      },
      productsCurrentChange(pageIndex) {
        this.page.pageIndex = pageIndex;
        this.getGoodsListByGuids()
      },

      delData(guid) {
        let that = this;
        if (this.multipleSelection.length == 1) {
          this.page = {
            pageIndex: 1,
            pageSize: 50,
            totalRows: 0,
            goodsName: null,
            isCompetitor: null
          }
          this.productInformationList = [];
          this.multipleSelection = [];
        } else {
          this.multipleSelection.forEach((item, index) => {
            if (item == guid) {
              that.multipleSelection.splice(index, 1)
            }
          })
          this.getGoodsListByGuids()
        }

      },
      //清空搜索
      emptySearchProducts() {
        this.page = {
          pageIndex: 1,
          pageSize: 50,
          totalRows: 0,
          goodsName: null,
          isCompetitor: null
        }
        if(!this.multipleSelection.length) return;
        this.getGoodsListByGuids()
      },
      //清空产品
      emptyProducts() {
        this.page = {
          pageIndex: 1,
          pageSize: 50,
          totalRows: 0,
          goodsName: null,
          isCompetitor: null
        }
        this.productInformationList = [];
        this.multipleSelection = [];
      },
      downLoadExcel() {
        window.open('/批量导入限定产品.xlsx');
      },
      //选择产品分页相关
      goodsSizeChange(pageSize) {
        this.goodsPage.pageSize = pageSize;
        this.getGoodsList()
      },
      goodsCurrentChange(pageIndex) {
        this.goodsPage.pageIndex = pageIndex;
        this.getGoodsList()
      },

      getGoodsList() {
        this.goodsPage.tenantGuid = this.sendTenantGuid
        this.api.postJson(`/${serverConfig.msProductService}/goods/data/get`, this.goodsPage).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.goodsInfoList = res.data.data.records;
            this.goodsPage.totalPage = res.data.data.totalPages;
            this.goodsPage.totalRows = res.data.data.totalRows;
            if (this.goodsInfoList && this.goodsInfoList.length) {
              this.goodsInfoList.forEach(item => {
                if (this.multipleSelection.includes(item.guid)) {
                  this.$refs["dataTable"].toggleRowSelection(item, true);
                }
              })
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
      },
      //弹层选完产品的事件
      sureChooseGoods() {
        if (!this.multipleSelection.length) {
          this.$message.error('请先选择产品');
          return
        }
        this.goodsVisible = false;
        this.getGoodsListByGuids();
      },
      emptySearchGoods() {
        this.goodsPage = {
          pageIndex: 1,
          pageSize: 50,
          totalRows: 0,
          totalPage: 0,
          goodsName: null,
          tenantGuid: this.goodsPage.tenantGuid
        }
        this.getGoodsList();
      },
      getGoodsListByGuids() {
        if(!this.multipleSelection.length) return;
        this.page.tenantGuid = this.sendTenantGuid
        this.page.guids = this.multipleSelection;
        this.api.postJson(`/${serverConfig.msProductService}/goods/data/get`, this.page).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.productInformationList = res.data.data.records;
            this.page.totalPage = res.data.data.totalPages;
            this.page.totalRows = res.data.data.totalRows;
          } else {
            this.$message.error(res.data.msg);
          }
        });
      },
      handleSelectionChange(list) {
        setTimeout(()=>{
          this.multipleSelection = [];
          list.forEach(item => {
            this.multipleSelection.push(item.guid)
          })
          this.multipleSelection = [...new Set(this.multipleSelection)];
        },500)
   
      },
      btn(row, col, event) {
        row.flag = !row.flag;
        this.$refs.dataTable.toggleRowSelection(row, row.flag);
      },
      //批量导入
      beforeUpload(file) {
        let filename = file.name;
        let arr = filename.split('.');
        if (arr[1] !== 'xls' && arr[1] !== 'xlsx' && arr[1] !== 'xlsm') {
          this.$message.error('上传文件只能是 excel/xls 格式!');
          return false;
        }
        return arr;
      },
      handleExceed(files, fileList) {
        this.$message.warning(
          `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`,
        );
      },
      changeFile(file, fileList) {
        this.fileList = [];
        this.fullscreenLoading = true;
        let formData = new FormData();
        formData.append('file', file.file);//传文件
        let url = `/${serverConfig.msProductService}/goods/import-goods-get-guid?tenantGuid=${this.sendTenantGuid}`
        this.api.postFile(url, formData).then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.multipleSelection = [...new Set(this.multipleSelection.concat(res.data.data.guidList))]
            this.successImportList = res.data.data.guidList;
            this.errorImportList = res.data.data.errorGoodsList;
            this.getGoodsListByGuids();
            if (this.errorImportList.length) {
              this.importVisible = true;
              return;
            }
            this.$message({
              type: 'success',
              message: '导入成功！'
            })
          } else {
            this.$message({
              type: 'warning',
              message: res.data.msg
            })
          }
        })
      },
      submitForm(isAll) {
        this.$emit('getLimitProducts', {
          goodsInfo: this.multipleSelection,
          isAll
        })
        this.closeGoodsLimit()
      }
    }
  };
  </script> 


  <style scoped>
  .header {
    background: #fff;
    margin: 4px 0;
    font-size: 16px;
    text-align: center;
    line-height: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    padding: 0 16px;
  
  }
  
  .header .back {
    background: #FFFFFF;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    width: 60px;
    height: 28px;
    line-height: 28px;
    font-size: 12px;
    cursor: pointer;
  }
  
  .header .task-title {
    flex: 1;
    font-weight: 500px;
  }
  
  .header .task-title span {
    font-size: 12px;
    color: #4fa1a4;
    margin-left: 5px;
    cursor: pointer;
  }
  .goods-limit{
    position:fixed;
    top:52px;
    right: 10px;
    left: 240px;
    background: #fff;
    bottom: 0;
    z-index:99;

  }
  .goods-content{
    padding:20px;
    height: calc(100% - 170px);
  }
  .search-wrap{
    margin-bottom: 20px;
  }
  /deep/ .table_header {
  background-color: #F0F0F0 !important;
  padding: 6px 0;
  color: #323233;
 
}
.btn-groups-operate {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
  
}

.btn-groups-operate .btn {
  margin-left: 10px;
}
 /deep/ .el-dialog__body{
  padding-top: 0;
 }
 .tips{
  text-align: left;
  padding-bottom: 10px;
  font-size: 13px;
  color: #222;
  font-weight: 500;
  color:red;
 }
  </style>
  
  
